import * as actions from './actions';
import * as mutations from './mutations';
import state from './state';

const hipoteca = {
   namespaced: true,
   actions,
   mutations,
   state,
};

export default hipoteca;
